import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-expiry-notification',
  templateUrl: './expiry-notification.component.html',
  styleUrl: './expiry-notification.component.scss'
})
export class ExpiryNotificationComponent {

@Input() message: string = '';
  @Input() severity: string = '';


constructor(private messageService: MessageService) {}


ngOnChanges() {
    this.messageService.add({ 
      severity: this.severity, 
      detail: this.message,  
      sticky:true,
      closable:false,
      data: {
          url: 'https://stantecdigitalservices.atlassian.net/servicedesk/customer/portal/29/group/134/create/1081', // any routerLink array or string
          linkText: 'Click here to renew'
  }

    });
  }

  closeToast() {
    this.message = '';
  }
}



